import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import CurrentStock from './CurrentStock';
import DailyTrends from './DailyTrends';
import DailySales from './DailySales';
import AverageOutage from './AverageOutage';
import WeeklySales from './WeeklySales';
import LoginLogs from './LoginLogs';
import { API } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

function Dashboard() {
  const { user } = useAuth();
  const selectedStore = 'all';
  const [loading, setLoading] = useState(true);
  const [showLoginLogs, setShowLoginLogs] = useState(false);
  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    // Load stores list
    API.getStores()
      .then(() => {
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading stores:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="dashboard-loading">Loading stores...</div>;
  }

  return (
    <div className="dashboard">
      <div className="dashboard-controls">
        {isAdmin && (
          <div className="controls-right">
            <button
              onClick={() => setShowLoginLogs(!showLoginLogs)}
              className="login-logs-toggle"
            >
              {showLoginLogs ? 'Hide' : 'Show'} Login Logs
            </button>
          </div>
        )}
      </div>

      {isAdmin && showLoginLogs && (
        <div className="dashboard-card full-width">
          <LoginLogs />
        </div>
      )}

      <div className="dashboard-grid">
        {/* <div className="dashboard-card full-width">
          <OutOfStockAlerts store={selectedStore === 'all' ? null : selectedStore} />
        </div> */}
        {isAdmin && (
          <div className="dashboard-card full-width">
            <DailySales />
          </div>
        )}
        <div className="dashboard-card full-width">
          <WeeklySales />
        </div>
        <div className="dashboard-card full-width">
          <CurrentStock store={selectedStore === 'all' ? null : selectedStore} />
        </div>

        <div className="dashboard-card full-width">
          <AverageOutage store={selectedStore === 'all' ? null : selectedStore} />
        </div>

        <div className="dashboard-card full-width">
          <DailyTrends store={selectedStore === 'all' ? null : selectedStore} />
        </div>

      </div>
    </div>
  );
}

export default Dashboard;

